<template>
    <div class="month-inventory fadeInRight">
        <div class="title-box clearfix">
            <span class="m-title">月库存统计</span>
            <el-form inline ref="monthInventoryForm" v-model="monthInventoryData" class="right themed-form search-form" style="height: 40px;line-height: 40px;">
                <el-form-item label="批次号">
                    <search-select :optionsMetaAll="optionsInCode" v-model="monthInventoryData.inCode"></search-select>
                </el-form-item>
                <el-form-item>
					<el-button icon="el-icon-search" type="primary" class="themed-button" @click="onSearch">查询</el-button>
				</el-form-item>

                <el-form-item>
					<el-button icon="el-icon-download" class="themed-button" type="info" @click="exportExcel">导出Excel</el-button>
				</el-form-item>
            </el-form>
        </div>

        <div class="content-box">
            <el-table
                border
                stripe
                ref="table"
                :max-height="maxTableHeight"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                >
                <el-table-column
                :show-overflow-tooltip="true"
                    prop="inCode"
                    label="入库批次"
                    min-width="120">
                </el-table-column>
                <el-table-column
                :show-overflow-tooltip="true"
                    prop="materielCode"
                    label="物料编号"
                    min-width="120">
                </el-table-column>
                <el-table-column
                :show-overflow-tooltip="true"
                    label="产品名称"
                    min-width="120">
                    <template slot-scope="scope">
                        <span>{{dictMapTrans(scope.row.productName,dictMap.productName)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                :show-overflow-tooltip="true"
                    label="产品类型"
                    min-width="120">
                    <template slot-scope="scope">
                        <span>{{dictMapTrans(scope.row.productType,dictMap.productType)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                :show-overflow-tooltip="true"
                    label="业务类型"
                    min-width="120">
                    <template slot-scope="scope">
                        <span>{{dictMapTrans(scope.row.businessType,dictMap.businessType)}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                :show-overflow-tooltip="true"
                    prop="outOfStockMonth"
                    label="当月出库数量"
                    min-width="120">
                </el-table-column>

                <el-table-column
                :show-overflow-tooltip="true"
                    prop="remainsOfStock"
                    label="剩余库存数量"
                    min-width="120">
                </el-table-column>
                
                <el-table-column
                :show-overflow-tooltip="true"
                    prop="caculateTime"
                    label="统计时间"
                    min-width="150">
                </el-table-column>
                
            </el-table>

            <el-pagination :current-page.sync="page"  :page-sizes="[5,10,15,50,100,1000]" :page-size="pageSize" style="text-align: left;margin-top: 20px;"
			 background layout="total,sizes,prev, pager, next,jumper" :total="total" @size-change="handleSizeChange" @current-change="onPageChange"></el-pagination>
        </div>

    </div>
</template>
<script>
import SearchSelect from '@/components/SearchSelect.vue'
import {inCodeMonthList,monthInventoryList,exportMonthInventory} from '@/api/stockManagement.js'
import resize from '@/mixins/resize.js'
export default {
    name:'monthlyInventory',
    components:{SearchSelect},
    mixins:[resize],
    data(){
        return {
            monthInventoryData:{
                inCode:''
            },
            optionsInCode:[
                {label:'全部',value:''}
            ],
            tableData:[],
            page:1,
            pageSize:15,
            total:0,
            dictMap:''
        }
    },
    created(){
        this.getInCodeMonthList()
        this.getMonthInventoryList()
    },
    methods:{
        getInCodeMonthList(){
            inCodeMonthList().then(res=>{
                this.dictMap = res.dict
                let arrList = [{label:'全部',value:''}]
                res.data.forEach(item=>{
                    arrList.push({label:item.inCode,value:item.inCode})
                })
                this.optionsInCode = arrList
            })
        },
        dictMapTrans(val,dictGroup){
            let returnVal = val
            dictGroup.forEach(element=>{
                if(val == element.dictKey){
                    returnVal = element.dictValue
                }
            })
            return returnVal
        },
        getMonthInventoryList(){
            let parame = {
                pageSize:this.pageSize,
                pageNo:this.page
            }
            Object.assign(this.monthInventoryData,parame)
            monthInventoryList(this.monthInventoryData).then(res=>{
                this.tableData = res.data.rows
                this.total = res.data.count
            })
        },
        onPageChange(page){
			this.page = page
			this.getMonthInventoryList()
		},
		handleSizeChange(size){
			this.pageSize = size
			this.getMonthInventoryList()
        },
        onSearch(){
            this.page = 1
            this.getMonthInventoryList()
        },
        exportExcel(){
            exportMonthInventory(this.monthInventoryData).then(res=>{
					if (res.system_result_key == '0') {
						this.$alert('导出成功，请到导出记录中下载', '提示', {
						    confirmButtonText:'确定',
						}).then(()=>{
							this.$router.push('/tob/i_export_list')
						});
					}else{
						this.$message({
						    showClose: true,
						    message: res.system_result_message_key,
						    type: 'error'
						});
					}
				})
        },
    }
}
</script>
<style>
    .month-inventory .el-form-item__label{
        vertical-align: top;
    }
</style>